import React from 'react'
import { BottomSheet } from '../../../commons/BottomSheet'
import { localiseTerms, t } from '../../../../utils/markets'

// market (UAE / Malaysia only) swaps "aircon" for the local term.
export const AirconServiceGuide = ({ setIsShowAirconGuide, market }) => {

    return (
        <BottomSheet 
            isOpen={true} 
            onClose={() => setIsShowAirconGuide(false)}
            maxWidth="lg"
        >
            {/* Header */}
            <BottomSheet.Header>
                <BottomSheet.Title>{localiseTerms('Aircon Service Guide', market)}</BottomSheet.Title>
                <BottomSheet.Subtitle>Choose the right service for your needs</BottomSheet.Subtitle>
            </BottomSheet.Header>

            {/* Content */}
            <BottomSheet.Content>
                <div className='space-y-4'>
                    {/* General Servicing */}
                    <div className="bg-blue-50 border border-blue-100 rounded-xl p-4">
                        <div className="flex items-start gap-3">
                            <span className="text-2xl">🧹</span>
                            <div className="flex-1">
                                <h4 className="font-semibold text-gray-800 mb-2">{market ? t(market, 'acGeneral') : 'General Servicing'}</h4>
                                <ul className="text-sm text-gray-600 space-y-1">
                                    <li>• Recommended every <span className="font-semibold text-blue-600">3-6 months</span></li>
                                    <li>• Regular cleaning and maintenance</li>
                                    <li>• {localiseTerms('Keeps aircon efficient, prevents dust buildup', market)}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Chemical Wash */}
                    <div className="bg-purple-50 border border-purple-100 rounded-xl p-4">
                        <div className="flex items-start gap-3">
                            <span className="text-2xl">🧪</span>
                            <div className="flex-1">
                                <h4 className="font-semibold text-gray-800 mb-2">{market ? t(market, 'acChemicalWash') : 'Chemical Wash'}</h4>
                                <ul className="text-sm text-gray-600 space-y-1">
                                    <li>• When {localiseTerms('aircon', market)} is <span className="font-semibold text-purple-600">not cooling well</span></li>
                                    <li>• No service done in 6 months to 1 year</li>
                                    <li>• Removes dirt and bacteria with chemicals</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Chemical Overhaul */}
                    <div className="bg-orange-50 border border-orange-100 rounded-xl p-4">
                        <div className="flex items-start gap-3">
                            <span className="text-2xl">💧</span>
                            <div className="flex-1">
                                <h4 className="font-semibold text-gray-800 mb-2">{market ? t(market, 'acChemicalOverhaul') : 'Chemical Overhaul'}</h4>
                                <ul className="text-sm text-gray-600 space-y-1">
                                    <li>• For <span className="font-semibold text-orange-600">water leaking</span> issues</li>
                                    <li>• Heavily choked fan coil units</li>
                                    <li>• Deep cleaning by full dismantling</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Comparison Note */}
                    <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 text-sm">
                        <p className="text-amber-800">
                            <strong>💡 Tip:</strong> Chemical Wash uses minimal dismantling. 
                            Chemical Overhaul requires complete dismantling for thorough cleaning - 
                            recommended for better results.
                        </p>
                    </div>
                </div>
            </BottomSheet.Content>

            {/* Footer */}
            <BottomSheet.Footer className="text-center">
                <BottomSheet.CloseButton variant="primary" className="w-full">
                    Got it!
                </BottomSheet.CloseButton>
            </BottomSheet.Footer>
        </BottomSheet>
    )
}
